<h2 *ngIf="isNewPost" mat-dialog-title>
  {{ "brand.campaign.contentCalendarVideoPost.createTitle" | translate }}
</h2>
<h2 *ngIf="!isNewPost" mat-dialog-title>
  {{ "brand.campaign.contentCalendarVideoPost.updateTitle" | translate }}
</h2>
<mat-dialog-content>
  <form>
    <div class="video-upload-area">
      <p class="section__title">
        {{ "brand.campaign.contentCalendarVideoPost.postVideo" | translate }}
        <app-tooltip
          text="{{
            'brand.campaign.contentCalendarVideoPost.linkedInPostVideoToolTip'
              | translate
          }}"
        ></app-tooltip>
      </p>
      <video
        *ngIf="post?.videoUrl"
        style="width: 100%"
        src="{{ post.videoUrl }}"
        controls
      ></video>
      <app-file-uploader
        [uploaderTitle]="
          'brand.campaign.contentCalendarVideoPost.dragDropVideo' | translate
        "
        [uploaderSubtitle]="videoUploaderSubtitle"
        (apiResponse)="handleVideoUploadResponse($event)"
        [uploadUrl]="uploaderUrl"
        [uploadData]="uploadData"
        [fieldName]="uploaderFieldName"
        [acceptFormat]="acceptVideoFormat"
        (uploadError)="fileUploaderErrorHandler($event)"
        [maxFileSize]="MAX_FILE_SIZE"
        [responseMapper]="fileUploaderResponseMapper"
      />
    </div>

    <app-brand-campaign-content-form-post-suggested-text
      *ngIf="allValidPostTags"
      #suggestedText
      [platform]="LINKEDIN"
      [text]="post.text"
      [postTags]="allValidPostTags"
      [type]="campaign.type"
      (textChanged)="textChanged($event)"
      [maxLength]="330"
    >
    </app-brand-campaign-content-form-post-suggested-text>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <app-content-creation-dialog-actions
    [creationMode]="isNewPost"
    [isSaving]="isSaving"
    [isSaveDisabled]="isSaveDisabled"
    (cancel)="onActionCancel()"
    (save)="onActionSave()"
    (preview)="onActionPreview()"
  ></app-content-creation-dialog-actions>
</mat-dialog-actions>
